export const DATABASE_DATE_FORMAT = "yyyy-MM-dd HH:mm:ss"

export const ONE_SECOND_IN_MILLISECONDS = 1_000
export const ONE_MINUTE_IN_SECONDS = 60
export const ONE_HOUR_IN_SECONDS = ONE_MINUTE_IN_SECONDS * 60
export const ONE_DAY_IN_SECONDS = ONE_HOUR_IN_SECONDS * 24
export const ONE_WEEK_IN_SECONDS = ONE_DAY_IN_SECONDS * 7
export const ONE_MONTH_IN_SECONDS = ONE_DAY_IN_SECONDS * 30
